import { useLocation } from "react-router-dom";

const LoginFailed = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const error = params.get("error_message");
    return (
        <div className="grow border-x-8 border-custom-bg-gray overflow-auto">
            <div className="max-w-3xl px-6 mx-auto flex flex-col left justify-center p-12 gap-y-4">
                <h1 className="text-darkpink dark-pink font-chat-intro-title text-chat-intro-title">
                    Das sollte nicht passieren
                </h1>
                <div className="font-chat-intro text-chat-intro mb-4 pt-8">
                    Leider hat es ein Problem beim Login gegeben.
                </div>
                {error && (
                    <div className="font-chat-intro text-chat-intro mb-4 pt-4">
                        <h2 className="">Fehlermeldung:</h2>
                        <pre className="bg-gray-100 p-4 rounded-lg">{error}</pre>
                    </div>
                )}
                <div className="font-chat-intro text-chat-intro mb-4 pt-4">
                    Um herauszufinden, warum das passiert ist und um Dir möglichst schnell helfen zu können schreibe
                    bitte eine kurze Mail an:{" "}
                    <a
                        href="mailto:help.nextgen-ai@crf-education.com?subject=Fehler%20beim%20LogIn"
                        className="underline"
                    >
                        help.nextgen-ai@crf-education.com
                    </a>
                    .
                </div>
            </div>
        </div>
    );
};

export default LoginFailed;
